export const PROFILE_PUSH_POPUP_ENABLED = true;

const isProfilePushFreezeActive = () => {
    return PROFILE_PUSH_POPUP_ENABLED
}

export default isProfilePushFreezeActive;